import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openStartSessionModal } from '../../data/fileImport/modalActions';

class SessionStatus extends Component {
  render() {
    switch (this.props.sessionStatus) {
      case 'valid':
        return (
          <span className={`session__status--${this.props.sessionStatus}`}>
            <i className="icon-session-start icon" />
          </span>
        );
      case 'invalid':
      case 'noShow':
      case 'exclusion':
      case 'refused':
        return (
          <span className={`session__status--${this.props.sessionStatus}`}>
            <i className="icon-session-invalid icon" />
          </span>
        );
      default:
        return (
          <span
            className="session__status"
            onClick={event => this.props.dispatch(openStartSessionModal(this.props.sessionId))}
          >
            <i className="icon-session-add icon" />
          </span>
        );
    }
  }
}

SessionStatus.propTypes = {
  sessionId: PropTypes.number,
  sessionStatus: PropTypes.string
};

export default connect()(SessionStatus);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/SessionStatus.js